<template lang="html">
  <div class="document-details-modal-component">
    <template v-if="isLoading">
      <circle-loader>
        <slot name="placeholderloading">загружаем...</slot>
      </circle-loader>
    </template>
    <template v-else>
      <card-in-model-errors-list-wrapper :messages="model.errors.errors"><a class="label"
                                                                            @click.prevent="showDetails">
        <slot name="placeholder">детали документа</slot>
      </a></card-in-model-errors-list-wrapper>
    </template>
    <regular-modal class="modal-document-details" ref="documentDetailsModal" width="900"
                   height="auto" :title="'Детали документа ' + id">
      <!--modal(:name="modalName" :adaptive="true" :width="900" height="auto" :clickToClose="true").modal-document-details-->
      <div class="modal-inner">
        <template v-if="hasDocumentDetails">
          <!--div {{documentDetails}}-->
          <table class="detail-view table table-striped table-condensed">
            <tbody>
            <tr>
              <th>ID</th>
              <td>{{ documentDetails.id }}
                (<a
                  :href="`/backofficeapi/report/pdf/document?id=${documentDetails.id}&pdflocale=ru&download=1`">PDF
                   рус</a>,
                <a
                  :href="`/backofficeapi/report/pdf/document?id=${documentDetails.id}&pdflocale=en&download=1`">PDF
                  англ</a>
                )
              </td>
            </tr>
            <tr>
              <th>Статус</th>
              <td>
                <div class="document-status"><span>{{ documentDetails.state }}</span>
                  <template v-if="documentDetails.state === 'VIRTUAL'">
                    <split-document-icon></split-document-icon>
                  </template>
                </div>
              </td>
            </tr>
            <template v-if="documentDetails.state === 'VIRTUAL'">
              <tr>
                <th></th>
                <td>Это виртуальный сплит-документ, порождающий несколько других.</td>
              </tr>
            </template>
            <tr v-if="documentDetails.children.length &gt; 0">
              <th>Сплит-документы</th>
              <td>
                <template v-for="childId in documentDetails.children">
                  <document-details-modal :id="childId">
                    <template v-slot:placeholder>{{ childId }}</template>
                  </document-details-modal>
                </template>
              </td>
            </tr>
            <tr>
              <th>Комментарий</th>
              <td>{{ documentDetails.comment }}</td>
            </tr>
            <tr>
              <th>Дата</th>
              <td>{{ documentDetails.createdAt|tsFormat }}</td>
            </tr>
            <tr>
              <th>Канал</th>
              <td>{{ documentDetails.channel }}</td>
            </tr>
            <tr>
              <th>Способ подтверждения</th>
              <td>{{ documentDetails.verificationType }}</td>
            </tr>
            <template v-if="documentDetails.batch">
              <tr>
                <th>Батч</th>
                <td>
                  <template v-if="disableMassPaymentDetails">{{ documentDetails.batch.id }}
                  </template>
                  <template v-else>
                    <mass-payment-details-modal
                      :id="documentDetails.batch.id"></mass-payment-details-modal>
                  </template>
                </td>
              </tr>
              <tr>
                <th>- Батч / номер платежа в системе клиента</th>
                <td>{{ documentDetails.batch.number }}</td>
              </tr>
              <tr>
                <th>- Батч / тип платежа</th>
                <td>{{ documentDetails.batch.type }}</td>
              </tr>
              <tr>
                <th>- Батч / дата</th>
                <td>{{ documentDetails.batch.timestamp | tsFormat }}</td>
              </tr>
            </template>
            <tr>
              <th>Пользователь</th>
              <td><a :href="documentDetails.user.profileUrl">{{ documentDetails.user.username }}</a>

                ({{ documentDetails.user.id }})
              </td>
            </tr>
            <tr>
              <th>Сумма</th>
              <td>{{ documentDetails.amount|moneyFormat(documentDetails.currency) }}
                {{ documentDetails.currency|backofficeCurrencyFilter }}
              </td>
            </tr>
            <tr>
              <th>Сумма назначения</th>
              <td>
                <template v-if="documentDetails.destAmount">
                  {{ documentDetails.destAmount|moneyFormat(documentDetails.destCurrency) }}
                  {{ documentDetails.destCurrency|backofficeCurrencyFilter }}
                </template>
                <template v-else>&mdash;</template>
              </td>
            </tr>
            <tr>
              <th>Комиссия</th>
              <td>
                <template v-if="documentDetails.tax &amp;&amp; documentDetails.tax &gt; 0">
                  {{ documentDetails.tax|moneyFormat(documentDetails.currency) }}
                  {{ documentDetails.currency|backofficeCurrencyFilter }}
                </template>
                <template v-else>&mdash;</template>
              </td>
            </tr>
            <tr>
              <th>Направление</th>
              <td>{{ documentDetails.outcome ? 'исходящий' : 'входящий' }}</td>
            </tr>
            <tr>
              <th>Назначение</th>
              <td>{{ documentDetails.description }}</td>
            </tr>
            <tr>
              <th>Корреспондент</th>
              <td>{{ documentDetails.correspondent }}</td>
            </tr>
            <tr>
              <th>ExternalKey</th>
              <td>{{ documentDetails.raw.externalKey }}</td>
            </tr>
            <tr>
              <th>Поле "account"</th>
              <td>{{ documentDetails.raw.account }}</td>
            </tr>
            <tr>
              <th>Отправитель</th>
              <td>
                <template v-if="documentDetails.senderAccount">
                  {{ documentDetails.senderAccount.number }}
                </template>
                <template v-if="documentDetails.isSystemSenderAccount"><span>


                    (один из

                    <a href="/backoffice/default/accounts">системных счетов</a>)</span></template>
              </td>
            </tr>
            <tr v-if="documentDetails.crypto &amp;&amp; documentDetails.crypto.txid">
              <th>Crypto TxId</th>
              <td>
                <div>{{ documentDetails.crypto.txid }}</div>
                <template v-if="isTron &amp;&amp; documentDetails.outcome">
                  <tron-payment-guess-modal :payment-id="documentDetails.id"
                                            :invest-document="true">
                    <template v-slot:link="{showDetails}"><a class="label tron-tx-details-link"
                                                             href="#" @click.prevent="showDetails">Детали
                      Tron транзакции</a></template>
                  </tron-payment-guess-modal>
                </template>
              </td>
            </tr>
            <tr>
              <th>Система</th>
              <td>
                <template v-if="documentDetails.raw.system">{{ documentDetails.raw.system.name }}
                  ({{ documentDetails.raw.system.id }})
                </template>
              </td>
            </tr>
            <tr>
              <th>Сервис</th>
              <td>
                <template v-if="documentDetails.raw.service">{{ documentDetails.raw.service.name }}
                  ({{ documentDetails.raw.service.id }})
                </template>
              </td>
            </tr>
            <!--tr
            th Получатель
            td
              template(v-if="documentDetails.receiverAccount")
                | {{documentDetails.receiverAccount.number}}
              template(v-if="documentDetails.isSystemReceiverAccount")
                span
                  |
                  |
                  | (один из
                  |
                  |
                  a(href="/backoffice/default/accounts") системных счетов
                  | )
            -->
            </tbody>
          </table>
        </template>
      </div>
    </regular-modal>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import {
  DocumentDetailsInterface,
  GateInternalDocumentDetailsModel,
} from '@/backoffice/components/pages/gate/gate';
import CircleLoader from '@/components/loaders/CircleLoader.vue';
import CardInModelErrorsListWrapper
  from '@/backoffice/components/pages/documents/cardsin/CardInModelErrorsListWrapper.vue';
import {formatUnixDateFilter} from '@/models/filters/datetime';
import {MoneyFormatFilter} from '@/models/filters/money';

import {backofficeCurrencyFilter} from '@/models/core/currency';
import SplitDocumentIcon from "@/backoffice/components/icons/SplitDocumentIcon.vue";
import RegularModal from "@/backoffice/components/modals/RegularModal.vue";
import TronPaymentGuessModal from "@/backoffice/components/crypto/TronPaymentGuessModal.vue";

@Component({
  name: 'document-details-modal',
  components: {
    TronPaymentGuessModal,
    RegularModal,
    SplitDocumentIcon,
    MassPaymentDetailsModal: () => import('@/backoffice/components/pages/documents/mass/MassPaymentDetailsModal.vue'),
    CardInModelErrorsListWrapper,
    CircleLoader
  },
  filters: {
    tsFormat: formatUnixDateFilter,
    moneyFormat: MoneyFormatFilter,
    backofficeCurrencyFilter,
  },
})
export default class DocumentDetailsModal extends Vue {
  @Prop({required: true})
  id!: number

  @Prop({default: false})
  disableMassPaymentDetails!: boolean

  modalId = Math.random();

  model: GateInternalDocumentDetailsModel = new GateInternalDocumentDetailsModel();

  get modalName() {
    return `modal-document-details-${this.id}-${this.modalId}`;
  }

  get isLoading(): boolean {
    return this.model.loadingStatus.isLoading;
  }

  get isTron() {
    return this.hasDocumentDetails && ['Tron'].indexOf(this.documentDetails.raw.system.name) !== -1;
  }

  showDetails() {
    this.model.errors.clear();
    this.model.loadDocumentDetails(this.id).then((document) => {
      // this.$modal.show(this.modalName);
      (this.$refs.documentDetailsModal as RegularModal).showModal();
    });
    return null;
  }

  get documentDetails(): DocumentDetailsInterface | null {
    return this.model.document;
  }

  get hasDocumentDetails() {
    return Boolean(this.model.document);
  }
}
</script>

<style scoped lang="less">
.modal-document-details {
  table {
    margin: 0;
  }

  td {
    text-align: left;
    white-space: normal;
    word-break: break-all;
  }

  th {
    text-align: left;
    width: auto;
    width: fit-content;
    min-width: 25%;
  }

  th, td {
    color: #333333;
    padding: 1px 5px;
    border: 1px solid #cccccc;

    &.break-words {
      word-break: break-all;
    }
  }

  width: 100%;
  box-sizing: border-box;
}

.modal-document-details {

  .document-status {
    display: grid;
    grid-template-columns: max-content auto;
    grid-gap: 20px;
    grid-auto-flow: column;
  }

  //::v-deep {
  //  .vm--modal {
  //    padding: 15px;
  //    max-height: 80vh;
  //    overflow-y: auto;
  //    max-width: 80vw;
  //    //width: 80%;
  //
  //    &::-webkit-scrollbar {
  //      width: 14px;               /* width of the entire scrollbar */
  //    }
  //    &::-webkit-scrollbar-track {
  //      background: #ffffff;        /* color of the tracking area */
  //    }
  //    &::-webkit-scrollbar-thumb {
  //      background-color: #99bc50;    /* color of the scroll thumb */
  //      border-radius: 20px;       /* roundness of the scroll thumb */
  //      border: 4px solid #ffffff;  /* creates padding around scroll thumb */
  //    }
  //  }
  //}
}
</style>
